import * as Constants from "../constants";
import * as InitialStates from "../constants/initialStates";

export default function liveStreamReducer(
  state = InitialStates.getInitialLiveStreamState(),
  action
) {
  switch (action?.type) {
    case Constants.GET_ENTRYPOINTS_LIVES: {
      return {
        ...state,
        loadingEntrypointsLives: true,
      };
    }
    case Constants.GET_ENTRYPOINTS_LIVES_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        loadingEntrypointsLives: false,
        entrypointsLives: data?.liveStreams || [],
      };
    }
    case Constants.GET_ENTRYPOINTS_LIVES_ERROR: {
      return {
        ...state,
        loadingEntrypointsLives: false,
        errorFetchingEntrypointsLives: true,
      };
    }
    case Constants.GET_FEATURED_LIVES: {
      return {
        ...state,
        loadingFeaturedLives: true,
      };
    }
    case Constants.GET_FEATURED_LIVES_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        loadingFeaturedLives: false,
        featuredLives: data?.liveStreams || [],
      };
    }
    case Constants.GET_FEATURED_LIVES_ERROR: {
      return {
        ...state,
        loadingFeaturedLives: false,
        errorFetchingFeaturedLives: true,
      };
    }
    case Constants.GET_NEXT_LIVES: {
      return {
        ...state,
        loadingNextLives: true,
      };
    }
    case Constants.GET_NEXT_LIVES_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        loadingNextLives: false,
        nextLives: data?.liveStreams || [],
      };
    }
    case Constants.GET_NEXT_LIVES_ERROR: {
      return {
        ...state,
        loadingNextLives: false,
        errorFetchingNextLives: true,
      };
    }
    default:
      return state;
  }
}
